import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../../contexts/auth/Context";
import { decodeUserInfo } from "../../../utils/user";
import { getHomeRouteByRole } from "../../../utils/route-permissions";
import type { PlatformRole } from "../../../utils/zod/common";

interface RoleProtectedRouteProps {
  allowedRoles?: PlatformRole[];
  redirectPath?: string;
}

export const RoleProtectedRoute = ({
  allowedRoles,
  redirectPath,
}: RoleProtectedRouteProps) => {
  const { token } = useAuth();
  const { role } = decodeUserInfo(token);
  if (!allowedRoles) {
    return <Outlet />;
  }

  if (!role || !allowedRoles.includes(role)) {
    const redirect = redirectPath || getHomeRouteByRole(role);
    return <Navigate to={redirect} replace />;
  }

  return <Outlet />;
};
